export enum CampaignStatus {
  InDesign = 1,
  Planned = 2,
  Open = 3,
  Closed = 4,
  Blocked = 5,
}
